import reducers from "./reducers/reducers";
import { configureStore } from '@reduxjs/toolkit'

const store = configureStore(reducers);

export type RootState = ReturnType<typeof store.getState>;

export default store;
